import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap = {
    pay: true
};

interface Props {
    data: {
        productTitle: string;
        hotelName: string;
        effectiveEndTime: string;
        productCount: number;
        _disable: false;
    };
}

class Food extends Component<Props> {
    public static formatData = (data: any) => {
        const newData = { ...data };
        // 订单状态
        newData._orderStatus = statusMap[newData.status];
        // icon
        newData.iconfont = '\uf1e8';
        newData.iconColor = '#f48221';

        // 价格
        newData.currency = (newData.currency || '').trim();
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        return newData;
    };

    public render() {
        const {
            data: { productTitle, hotelName, effectiveEndTime, productCount, _disable } = {}
        } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                <Text style={styles.newOrderTitle} numberOfLines={2}>
                    {productTitle}
                </Text>

                {Boolean(hotelName) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {hotelName}
                    </Text>
                )}
                {Boolean(effectiveEndTime) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        有效期至
                        {effectiveEndTime}
                    </Text>
                )}
                {Boolean(productCount) && (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        数量
                        {productCount}
                    </Text>
                )}
            </View>
        );
    }
}

export default Food;
